// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_nk-0";
export var buttonContainer = "_nk-3";
export var cancelButton = "_nk-4";
export var headerSection = "_nk-6";
export var headerTitle = "_nk-9";
export var messageSideLeft = "_nk-1";
export var messageSideRight = "_nk-2";
export var orderNumberContainer = "_nk-7";
export var orderNumberLabel = "_nk-8";
export var submitButton = "_nk-5";